
<template>
    <div :class="['wrapper']">
        <div class="video">
            <img class="banner" src="@/assets/examVideoV2/picture_kcsplby01@2x.png">
            <div class="video-wrap">
                <div class="video-head">
                    <img src="@/assets/examVideoV2/icon_bf@2x.png">
                    <h4>{{videoInfo.examPlaceName}}</h4>
                    <span class="count">共{{videoInfo.routeCount}}条路线</span>
                </div>
                <div class="video-content">
                    <div v-for="item in videoInfo.videoList" :key="item.id" class="video-item" @click="jumpPage(item.id)">
                        <div class="video-item__thumbnail">
                            <img :src="item.coverUrl" />
                            <div class="video-item__mask">
                                <div class="place-name">{{item.examPlaceName}}</div>
                                <div class="name">{{item.name}}</div>
                                <div class="timer">{{formatSeconds(item.duration)}}</div>
                                <img class="player" src="@/assets/examVideoV2/icon_playbig@2x.png" alt="">
                                <img v-if="item.vipFlag" class="vip" src="@/assets/examVideoV2/icon_vipbig@2x.png" alt="">
                            </div>
                        </div>
                        <div class="video-item__name">{{item.name}}</div>
                        <div class="video-item__operate">
                            <span><van-icon class="icon" name="eye-o" />{{item.clickRate}}</span>
                            <span><van-icon class="icon" name="good-job-o" />{{item.likeNum}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Icon, Toast } from 'vant'
import { formatSeconds } from '../../../utils'
export default {
    name: 'vipCoachGoodsVideoList',
    components: {
        [Icon.name]: Icon
    },
    data () {
        return {
            videoInfo: []
        }
    },
    methods: {
        formatSeconds,
        getList () {
            const { examPlaceBatchId } = this.$route.query
            this.$api.getRouteVideoList({
                subject: 3,
                examPlaceBatchId
            }).then(res => {
                if (res.status) {
                    this.videoInfo = res.result
                } else {
                    Toast(res.message)
                }
            })
        },
        jumpPage (id) {
            console.log(id)
            // const query = this.$route.query
            // query.id = id
            // this.$router.push({ name: 'vipCoachGoodsVideoDetail', query })
        }
    },
    mounted () {
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
    .wrapper{
        background: #FEECDE;
        .header{
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 3;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 44px;
            background: #ffffff;
            .header-main{
                font-size:18px;
                font-family:PingFangSC;
                font-weight:bold;
                color: #333333;
            }
            .header-left,.header-right{
                display: flex;
                padding: 15px 10px;
                width: 24px;
                height: 24px;
                font-size: 0;
                line-height: 1;
                img{
                    width: 24px;
                    height: 24px;
                }
            }
        }
        .header-pre{
            height: 44px;
        }
    }
    .banner{
        width: 100%;
        vertical-align: middle;
    }
    .video{
        * {
            box-sizing: border-box;
        }
    }
    .video-wrap{
        padding: 20px 10px;
    }
    .video-head{
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        line-height: 1;
        img{
            margin-right: 4px;
            width: 15px;
            height: 15px;
            vertical-align: middle;
        }
        h4{
            flex: 1;
            color: #333333;
            font-size: 20px;
            font-weight: 600;
        }
        .count{
            font-size: 13px;
            color: #FF6F04;
        }
    }
    .video-item{
        margin-bottom: 20px;
        &:last-child{
            margin-bottom: 0;
        }
        &__thumbnail {
            position: relative;
            width: 355px;
            height: 229px;
            border-radius: 11px;
            overflow: hidden;
            &>img{
                width: 100%;
                height: 100%;
            }
        }
        &__mask{
            position: absolute;
            background: rgba(0,0,0,0.5);
            top: 0;
            left:0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            line-height: 1;
            color:rgb(204,204,204);
            .place-name{
                font-size: 34px;
            }
            .name{
                margin-top: 25px;
                font-size: 31px;
                font-weight: 600;
            }
            .timer{
                position: absolute;
                right: 12px;
                bottom: 14px;
                color:#fff;
                font-size: 14px;
                line-height: 1;
            }
            .player{
                position: absolute;
                top:50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 48px;
                height: 48px;
            }
            .vip{
                position: absolute;
                top: 0;
                right: 12px;
                width: 50px;
                height: 22px;
            }
        }
        &__name{
            margin-top: 20px;
            color: #333333;
            font-size: 15px;
            font-weight: 400;
            line-height: 1;
        }
        &__operate{
            margin-top: 20px;
            display: flex;
            color: #999999;
            font-size: 13px;
            line-height: 1;
            span{
                display: flex;
                align-items: center;
                margin-right: 20px;
                .icon{
                    margin-right: 6px;
                }
            }
        }
    }
</style>
